{
  "ShortlistThemePreview": {
    "label": "Podgląd shortlisty",
    "sampleTitle": "Kampania letnia",
    "sampleDescription": "Nasze propozycje na letnią sesję. Zagłosuj na osoby, które chcesz zarezerwować.",
    "sampleChipAccent": "Na shortliście",
    "sampleChipTint": "Paryż",
    "sampleSecondaryAction": "Filtry"
  },
  "public.detail": {
    "search.placeholder": "Wyszukaj shortlistę",
    "hero.shortlistBy": "Shortlista stworzona w {{name}}",
    "empty.title": "Nikt nie został dodany do shortlisty",
    "empty.description": "Zbuduj swoją shortlistę, wybierając zasoby do prezentacji dla zainteresowanych stron",
    "filters.label": "Filtry",
    "item.emptyValue": "n/d",
    "passwordProtection": {
      "enterPassword": "Wpisz hasło, aby zobaczyć shortlistę",
      "placeholder": "Wpisz hasło",
      "viewShortlist": "Zobacz shortlistę"
    },
    "error": {
      "title": "Błąd podczas wyszukiwania shortlisty"
    }
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "Należy do mnie",
      "createdAt": "Utworzono po {{date}}",
      "publishedOnly": "Tylko opublikowane",
      "draftOnly": "Tylko szkice",
      "archived": "Pokaż zarchiwizowane",
      "between": "Pomiędzy {{startDate}} - {{endDate}}",
      "tags": {
        "and": " i ",
        "more": " więcej",
        "any": "Dowolny tag: {{tag}}",
        "match": "Pasujące tagi: {{tags}}"
      }
    }
  },
  "GridViewItemGallery": {
    "editGallery": "Edytuj galerię",
    "emptyGalleryTitle": "Pusta galeria",
    "emptyGalleryDescription": "Dodaj media dla tego zasobu",
    "addMedia": "Dodaj media"
  },
  "ShortlistVotes": {
    "upvote": "Głos za",
    "downvote": "Głos przeciw",
    "saveFailed": "Nie udało się zapisać głosu. Spróbuj ponownie."
  },
  "ShortlistMediaSidebarPage": {
    "draft": "Szkic",
    "votingDisabled": "Głosowanie jest wyłączone, gdy lista nie jest opublikowana",
    "commentingDisabled": "Komentowanie jest wyłączone, gdy lista nie jest opublikowana",
    "votingAndCommentingDisabled": "Głosowanie i komentowanie są wyłączone, gdy lista nie jest opublikowana"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "{{count}} z {{totalBlocks}} na shortliście",
      "previous": "Poprzedni na shortliście",
      "next": "Następny na shortliście"
    },
    "CommentList": {
      "label": "Komentarze",
      "guest": "Gość",
      "noComments": "Brak komentarzy",
      "startConversation": "Podziel się pierwszą opinią: {{name}}.",
      "startConversationNoName": "Napisz zespołowi, co sądzisz o tej osobie.",
      "commentsOff": "Komentarze są wyłączone",
      "anonymous": "Anonim"
    },
    "CommentInput": {
      "writeComment": "Napisz komentarz",
      "addComment": "Dodaj komentarz",
      "writeFirstComment": "Napisz pierwszy komentarz",
      "sendFailed": "Nie udało się wysłać komentarza. Spróbuj ponownie."
    },
    "GuestNameChangeForm": {
      "title": "Opinia gościa",
      "description": "Wpisz swoje imię poniżej, aby zostawić opinię",
      "placeholder": "Twoje imię",
      "saveChanges": "Zapisz zmiany"
    },
    "GuestInfo": {
      "youAre": "Jesteś {{name}}",
      "change": "Zmień"
    },
    "Details": {
      "noFields": "Ta shortlista nie ma wybranych pól do wyświetlenia",
      "loadFailed": "Nie udało się wczytać pól."
    },
    "Tabs": {
      "label": "Sekcje",
      "comments": "Komentarze",
      "details": "Szczegóły"
    }
  },
  "SetGuestNameModal": {
    "title": "Ustaw nazwę gościa",
    "description": "Musisz powiedzieć właścicielowi shortlisty, kim jesteś, zanim będziesz mógł głosować lub komentować osoby na liście",
    "yourName": "Twoje imię",
    "saveName": "Zapisz nazwę",
    "successfullyCreated": "Pomyślnie utworzono",
    "guestNameSet": "Nazwa gościa ustawiona"
  },
  "ShortlistCreateButton": {
    "create": "Utwórz shortlistę"
  },
  "ShortlistCreateDialog": {
    "title": "Utwórz shortlistę",
    "description": "Nazwij nową shortlistę, opisz ją i dodaj tagi.",
    "titleLabel": "Tytuł",
    "titlePlaceholder": "Tytuł shortlisty",
    "titleRequired": "Wpisz tytuł",
    "descriptionLabel": "Opis",
    "descriptionPlaceholder": "Klienci zobaczą go pod tytułem",
    "tagsLabel": "Tagi",
    "create": "Utwórz"
  },
  "CardFieldsDialog": {
    "title": "Pola kart",
    "description": "Które pola pokazuje każda karta tej shortlisty, wszystkim, także klientowi.",
    "rateHint": "pierwsza karta stawek",
    "noCatalog": "Typy zasobów tego workspace’u nie mają pól, które karta może pokazać.",
    "onCards": "Na kartach",
    "selectedCount": "Wybrano {{count}} z {{total}}",
    "order": "Kolejność pól kart",
    "cut": "Karty pokazują pola powyżej · szczegóły pokazują wszystkie",
    "reorderHint": "Przeciągnij, aby zmienić kolejność. Przeciągnij pole nad linię, aby pokazać je na kartach.",
    "empty": "Nie ma jeszcze pól. Wybierz je z pól zasobów.",
    "preview": "Podgląd",
    "previewOf": "{{name}} · {{position, number}} z {{total, number}}",
    "previous": "Poprzednia osoba",
    "next": "Następna osoba",
    "previewEmpty": "Dodaj osoby do shortlisty, aby zobaczyć podgląd karty.",
    "previewHint": "Puste wartości pokazują „—”, więc każda karta ma ten sam układ.",
    "unnamed": "Bez nazwy",
    "cancel": "Anuluj",
    "onSet": "Na planie",
    "teamSettings": "Ustawienia zespołu"
  },
  "ClientDefaultFilterDialog": {
    "title": "Domyślny filtr klienta",
    "description": "Klienci otwierają shortlistę z tym filtrem i mogą go u siebie wyczyścić.",
    "filters": "Filtry"
  },
  "AvailabilityDialog": {
    "title": "Dostępność",
    "description": "Czy karty pokazują dostępność i w jakich datach.",
    "show": {
      "label": "Pokazuj dostępność na kartach",
      "description": "Widzi ją każdy, kto otworzy shortlistę, także klient."
    },
    "dates": {
      "label": "Daty",
      "description": "Liczy się każda rezerwacja w tych datach, niezależnie od statusu.",
      "required": "Wybierz daty do sprawdzenia"
    },
    "preview": {
      "label": "Na karcie",
      "range": "{{from}} – {{to}}",
      "available": "Dostępny {{range}}",
      "booked": "{{status}} {{range}}",
      "privacy": "Klienci widzą status rezerwacji, nigdy nazwy produkcji."
    }
  },
  "SharingDialog": {
    "title": "Udostępnianie i dostęp",
    "description": "Link dla klienta, kto może go otworzyć, opinie klienta i branding.",
    "status": {
      "published": "Opublikowana",
      "draft": "Szkic"
    },
    "link": {
      "title": "Link",
      "hint": "Tu klient otwiera shortlistę. Link się nie zmienia po cofnięciu publikacji i ponownym opublikowaniu.",
      "copy": "Kopiuj",
      "draftHint": "Klienci otworzą go po publikacji.",
      "missing": "Ta shortlista nie ma jeszcze linku."
    },
    "access": {
      "title": "Kto może otworzyć",
      "link": {
        "label": "Każdy z linkiem",
        "description": "Bez hasła"
      },
      "password": {
        "label": "Link i hasło",
        "description": "Klienci wpisują je, żeby otworzyć link",
        "placeholder": "Hasło",
        "show": "Pokaż",
        "hide": "Ukryj",
        "generate": "Wygeneruj",
        "required": "Wpisz hasło albo pozwól otwierać link każdemu"
      }
    },
    "feedback": {
      "title": "Opinie klienta",
      "voting": {
        "label": "Głosowanie",
        "description": "Kciuk w górę lub w dół przy każdej osobie"
      },
      "comments": {
        "label": "Komentarze",
        "description": "Wątek przy każdej osobie"
      },
      "shared": {
        "label": "Wspólne opinie",
        "description": "Klienci widzą nawzajem swoje głosy i komentarze"
      },
      "notifications": {
        "label": "Powiadamiaj mnie e-mailem o nowych opiniach",
        "description": "Gdy ktoś zagłosuje lub skomentuje"
      }
    },
    "footer": {
      "published": "Opublikowana",
      "publishedOn": "Opublikowano {{day}}",
      "notPublished": "Jeszcze nieopublikowana"
    },
    "publish": "Opublikuj",
    "unpublish": "Cofnij publikację",
    "published": "Opublikowano. Klienci mogą już otworzyć link.",
    "unpublished": "Cofnięto publikację. Link zostaje ten sam na następny raz."
  },
  "ShortlistBrandingRow": {
    "defaultName": "Atellio",
    "profileHint": "Z ustawień profilu publicznego"
  },
  "ShareStatusButton": {
    "share": "Udostępnij",
    "published": "Opublikowana",
    "access": {
      "password": "hasło",
      "link": "każdy z linkiem"
    },
    "copyLink": "Kopiuj link"
  },
  "ShortlistPublicLink": {
    "copied": "Skopiowano link",
    "copyFailed": "Nie udało się skopiować linku. Zaznacz go tutaj i skopiuj samodzielnie:"
  },
  "ShortlistSettingsDialog": {
    "save": "Zapisz dla wszystkich",
    "saved": "Zapisano dla wszystkich",
    "unsavedChanges": "Te ustawienia mają niezapisane zmiany",
    "everyoneSees": "widzą wszyscy"
  },
  "BlockGalleryEditDialog": {
    "title": "Edytuj galerię",
    "description": "Zdjęcia, które {{name}} pokazuje na tej shortliście, w kolejności. Pierwsze to okładka.",
    "thisShortlistOnly": "Tylko ta shortlista",
    "everyoneSees": "Zapisane dla wszystkich na tej shortliście, także dla klienta.",
    "cancel": "Anuluj",
    "save": "Zapisz galerię",
    "uploading_one": "Wysyłanie {{count}}…",
    "uploading_few": "Wysyłanie {{count}}…",
    "uploading_many": "Wysyłanie {{count}}…",
    "uploading_other": "Wysyłanie {{count}}…",
    "saved": "Galeria zapisana",
    "profileAddFailed": "Galeria jest zapisana, ale nie udało się dodać nowych plików do tablicy profilu: {{name}}.",
    "unsavedChanges": "Ta galeria ma niezapisane zmiany.",
    "sources": "Dodaj z",
    "pinboard": "Tablica profilu",
    "loadingPinboard": "Wczytywanie tablicy profilu",
    "pinboardCount": "Tablica profilu · {{count}}",
    "upload": "Wyślij pliki",
    "searchPins": "Szukaj pinów po tagach",
    "pinboardHint": "Kliknij pin albo przeciągnij go do galerii. Trafi tam jako kopia; profil zostaje bez zmian.",
    "noPins": "Profil {{name}} nie ma jeszcze pinów. Wyślij zdjęcia albo dodaj link.",
    "noMatches": "Żaden pin nie ma tagu „{{query}}”.",
    "uploadFormats": "albo na galerię · JPG, PNG, WebP lub MP4, do 50 MB każdy",
    "orAddLink": "Albo dodaj z linku",
    "linkHint": "YouTube, Vimeo albo adres zdjęcia",
    "alsoAddToProfile": "Dodaj nowe pliki także do tablicy profilu: {{name}}",
    "inThisGallery": "W tej galerii",
    "startOver": "Zacznij od nowa z profilu",
    "reorderHint": "Przeciągnij, aby zmienić kolejność. Pierwsze zdjęcie to okładka na karcie.",
    "reorderHintNewFiles": "Nowe pliki trafiają na koniec. Przeciągnij, aby zmienić kolejność; pierwsze zdjęcie to okładka na karcie.",
    "new": "Nowe",
    "empty": "Brak zdjęć. Wybierz je w panelu albo przeciągnij tutaj.",
    "linkPreview": {
      "notAUrl": "To nie jest adres strony",
      "notAUrlHint": "Wklej link zaczynający się od https://.",
      "brokenPicture": "Nie udało się wczytać zdjęcia",
      "brokenPictureHint": "Sprawdź adres. Niektóre strony nie pozwalają innym pokazywać swoich zdjęć.",
      "missingVideo": "Nie da się pokazać tego filmu",
      "missingVideoHint": "Może być prywatny albo usunięty, albo link jest niepełny.",
      "unsupported": "Ten link nie prowadzi do zdjęcia ani filmu",
      "unsupportedHint": "Dodaj film z YouTube lub Vimeo albo adres zdjęcia."
    },
    "dropTitle": "Upuść tutaj zdjęcia lub filmy",
    "chooseFiles": "Wybierz pliki",
    "addPictures": "Dodaj zdjęcia",
    "picture": "zdjęcie",
    "pictures": "zdjęć",
    "pin": "pin",
    "pins": "pinów",
    "addSelected_one": "Dodaj {{count}} pin do galerii",
    "addSelected_few": "Dodaj {{count}} piny do galerii",
    "addSelected_many": "Dodaj {{count}} pinów do galerii",
    "addSelected_other": "Dodaj {{count}} pinów do galerii",
    "removeSelected_one": "Usuń {{count}} z galerii",
    "removeSelected_few": "Usuń {{count}} z galerii",
    "removeSelected_many": "Usuń {{count}} z galerii",
    "removeSelected_other": "Usuń {{count}} z galerii"
  },
  "BlockNote": {
    "label": "Notatka",
    "placeholder": "Napisz coś o: {{name}}",
    "placeholderUnnamed": "Napisz notatkę"
  },
  "ShortlistCard": {
    "noNote": "Brak notatki",
    "available": "Dostępny",
    "booked_one": "{{count}} rezerwacja",
    "booked_few": "{{count}} rezerwacje",
    "booked_many": "{{count}} rezerwacji",
    "booked_other": "{{count}} rezerwacji",
    "openGallery": "Otwórz galerię, zdjęcie {{index}} z {{count}}",
    "openGalleryPictures_one": "Otwórz galerię: {{count}} zdjęcie",
    "openGalleryPictures_few": "Otwórz galerię: {{count}} zdjęcia",
    "openGalleryPictures_many": "Otwórz galerię: {{count}} zdjęć",
    "openGalleryPictures_other": "Otwórz galerię: {{count}} zdjęcia",
    "previousPicture": "Poprzednie zdjęcie",
    "nextPicture": "Następne zdjęcie",
    "noPictures": "Brak zdjęć",
    "editGallery": "Edytuj galerię",
    "addPictures": "Dodaj zdjęcia",
    "pictureUnavailable": "Nie można wyświetlić tego zdjęcia",
    "morePictures_one": "jeszcze {{count}} zdjęcie",
    "morePictures_few": "jeszcze {{count}} zdjęcia",
    "morePictures_many": "jeszcze {{count}} zdjęć",
    "morePictures_other": "jeszcze {{count}} zdjęcia"
  },
  "ShortlistBoardPage": {
    "closeDetails": "Zamknij szczegóły",
    "shortlists": "Shortlisty",
    "resourceDetails": "Szczegóły zasobu",
    "belongsElsewhere": "Ta shortlista należy do innego workspace’u lub teamu",
    "belongsElsewhereHint": "Otwórz ją z listy shortlist workspace’u lub teamu, do którego należy.",
    "backToShortlists": "Wróć do shortlist",
    "draft": "Szkic",
    "published": "Opublikowana",
    "saveFailed": "Nie udało się zapisać zmiany."
  },
  "ShortlistBoardHeaderActions": {
    "mode": "Tryb",
    "edit": "Edycja",
    "preview": "Podgląd",
    "togglePreview": "Przełącz podgląd",
    "feedback": "Opinie · {{count}}",
    "more": "Więcej akcji",
    "sharingAndAccess": "Udostępnianie i dostęp"
  },
  "ShortlistBoardBatchActions": {
    "person": "osoba",
    "people": "osoby",
    "remove_one": "Usuń z shortlisty",
    "remove_few": "Usuń {{count}} z shortlisty",
    "remove_many": "Usuń {{count}} z shortlisty",
    "remove_other": "Usuń {{count}} z shortlisty",
    "removeFailed": "Nie udało się usunąć ich z shortlisty. Spróbuj ponownie."
  },
  "ShortlistAddResources": {
    "title": "Dodaj z bazy",
    "pick": "Zaznacz",
    "alreadyOnShortlist": "Już na tej shortliście",
    "noResults": "Brak pasujących zasobów.",
    "add": "Dodaj do shortlisty",
    "added_one": "Dodano {{count}} osobę do shortlisty",
    "added_few": "Dodano {{count}} osoby do shortlisty",
    "added_many": "Dodano {{count}} osób do shortlisty",
    "added_other": "Dodano {{count}} osoby do shortlisty",
    "addFailed": "Nie udało się dodać do shortlisty.",
    "available": "Dostępni {{start}} – {{end}}",
    "availableValue": "Dostępni",
    "availableSubject": "W datach shortlisty",
    "onlyWorkspace": "Tylko {{name}}",
    "allWorkspaces": "Wszystkie workspace’y",
    "willJoin_one": "{{count}} osoba dołączy do {{name}}",
    "willJoin_few": "{{count}} osoby dołączą do {{name}}",
    "willJoin_many": "{{count}} osób dołączy do {{name}}",
    "willJoin_other": "{{count}} osoby dołączy do {{name}}",
    "back": "Wstecz",
    "joinAndAdd": "Dołącz i dodaj",
    "notOnShortlist": "Spoza tej shortlisty"
  },
  "ShortlistBoardToolbar": {
    "onlyForMe": "Tylko dla mnie",
    "sortBy": "Sortuj: {{field}}",
    "sort": {
      "order": "własna kolejność",
      "votes": "najwięcej głosów",
      "name": "nazwa",
      "added": "ostatnio dodani"
    },
    "sizes": {
      "LARGE": "Duże",
      "MEDIUM": "Średnie",
      "SMALL": "Małe"
    },
    "everyoneSees": "Shortlista · widzą wszyscy",
    "cardFields": "Pola kart",
    "cardSize": "Rozmiar kart",
    "clientDefaultFilter": "Domyślny filtr klienta",
    "availability": "Dostępność",
    "addResources": "Dodaj zasoby"
  },
  "ShortlistBoardTags": {
    "title": "Tagi zespołu"
  },
  "ShortlistBoardHero": {
    "title": "Tytuł widoczny dla klienta",
    "titlePlaceholder": "Dodaj tytuł",
    "description": "Opis widoczny dla klienta",
    "descriptionPlaceholder": "Dodaj opis"
  },
  "ShortlistVersionSwitch": {
    "title": "Shortlisty",
    "newVersionDescription": "Testujesz nowe shortlisty. To wciąż wersja eksperymentalna — jeśli coś nie działa, wróć do klasycznej. Twoje shortlisty się nie zmieniają.",
    "oldVersionDescription": "Używasz klasycznych shortlist. Nowe są w wersji beta — możesz je wypróbować w każdej chwili."
  },
  "VoteButtons": {
    "voteUp": "Głosuj za",
    "voteDown": "Głosuj przeciw",
    "voteFailed": "Nie udało się zapisać głosu. Spróbuj ponownie.",
    "upvotes_one": "{{count}} głos za",
    "upvotes_few": "{{count}} głosy za",
    "upvotes_many": "{{count}} głosów za",
    "upvotes_other": "{{count}} głosu za",
    "downvotes_one": "{{count}} głos przeciw",
    "downvotes_few": "{{count}} głosy przeciw",
    "downvotes_many": "{{count}} głosów przeciw",
    "downvotes_other": "{{count}} głosu przeciw",
    "comments_one": "{{count}} komentarz",
    "comments_few": "{{count}} komentarze",
    "comments_many": "{{count}} komentarzy",
    "comments_other": "{{count}} komentarza",
    "openComments": "Komentarze"
  },
  "ShortlistClientHeader": {
    "people_one": "{{count}} osoba",
    "people_few": "{{count}} osoby",
    "people_many": "{{count}} osób",
    "people_other": "{{count}} osoby",
    "updated": "zaktualizowano {{when}}",
    "showMore": "Pokaż więcej",
    "showLess": "Pokaż mniej",
    "tags": "Tagi"
  },
  "ShortlistBoardBody": {
    "empty": "Na tej shortliście nikogo jeszcze nie ma.",
    "people": "Osoby na shortliście",
    "unnamed": "Zasób bez nazwy",
    "loading": "Wczytywanie…",
    "loadingPeople": "Wczytywanie osób",
    "loadFailed": "Nie udało się wczytać shortlisty.",
    "rowFailed": "Nie udało się wczytać tej osoby.",
    "saveFailed": "Nie udało się zapisać zmiany. Spróbuj ponownie.",
    "pick": "Zaznacz",
    "drag": "Przeciągnij, aby przenieść",
    "editGallery": "Edytuj galerię",
    "noMatches": "Nikt na tej shortliście nie pasuje."
  },
  "ShortlistSelector": {
    "updated": "Zmieniona {{when}}",
    "untitled": "Shortlista bez nazwy"
  },
  "PublicShortlistPasswordGate": {
    "private": "Prywatna shortlista",
    "label": "Hasło",
    "showPassword": "Pokaż hasło",
    "required": "Wpisz hasło",
    "wrong": "To hasło nie otworzyło shortlisty. Spróbuj ponownie.",
    "failed": "Nie udało się sprawdzić hasła. Sprawdź połączenie i spróbuj ponownie.",
    "submit": "Otwórz shortlistę",
    "help": "Nie masz hasła? Poproś o nie osobę, która wysłała Ci link."
  },
  "ShortlistClientBoard": {
    "unpublishedTitle": "Nieopublikowana",
    "unpublishedMessage": "Klienci, którzy otworzą link, zobaczą tę shortlistę jako niedostępną."
  },
  "PublicShortlistLoadFailed": {
    "title": "Nie udało się otworzyć shortlisty",
    "message": "Sprawdź połączenie i spróbuj ponownie."
  },
  "PublicShortlistUnavailable": {
    "title": "Ta shortlista jest niedostępna",
    "message": "Mogła zostać wycofana z publikacji albo link się zmienił. Poproś osobę, która ją udostępniła, o nowy link."
  },
  "ViewingAs": {
    "label": "Oglądasz jako",
    "labelGuest": "Oglądasz jako gość",
    "guest": "Gość",
    "addName": "Dodaj swoje imię i nazwisko",
    "changeName": "Zmień imię i nazwisko"
  },
  "ClientVoteProgress": {
    "voted": "Oceniono {{voted}} z {{total}}"
  },
  "AtellioFooter": {
    "madeWith": "Shortlista przygotowana w Atellio, platformie talentów dla zespołów produkcyjnych.",
    "learnMore": "Dowiedz się więcej"
  },
  "ShortlistSearchFilters": {
    "search": "Szukaj na shortliście"
  },
  "GuestNameDialog": {
    "title": "Twoje imię i nazwisko",
    "description": "Zanim zagłosujesz lub skomentujesz, powiedz właścicielowi shortlisty, kim jesteś.",
    "label": "Twoje imię i nazwisko",
    "placeholder": "Imię i nazwisko",
    "required": "Wpisz swoje imię i nazwisko",
    "save": "Zapisz imię i nazwisko"
  },
  "QrField": {
    "label": "Kod QR",
    "setUp": "Skonfiguruj kod QR",
    "notSetUp": "Nie wybrano jeszcze zawartości kodu QR.",
    "cannotBuild": "Nie można wygenerować kodu QR",
    "openSettings": "Ustawienia zespołu",
    "missing_one": "brakuje {{count}} pola",
    "missing_few": "brakuje {{count}} pól",
    "missing_many": "brakuje {{count}} pól",
    "missing_other": "brakuje {{count}} pola",
    "missingHint": "Wymagane dla typu tej osoby i puste: {{slots}}",
    "slots": {
      "gender": "Płeć",
      "bust": "Biust",
      "waist": "Talia",
      "height": "Wzrost",
      "shoe": "Obuwie",
      "bra_size": "Rozmiar biustonosza"
    },
    "copyValue": "Kopiuj wartość",
    "copied": "Skopiowano",
    "downloadSvg": "Pobierz SVG",
    "hoverHint": "Najedź na kod, aby zobaczyć, co czyta skaner. Kliknij go, aby ukryć lub pokazać logo.",
    "cannotBuildHint": "{{slots}}: zmapowane pole zostało usunięte z pól niestandardowych zespołu.",
    "hideLogo": "Ukryj logo",
    "showLogo": "Pokaż logo"
  },
  "ShortlistPdf": {
    "people_one": "{{count}} osoba",
    "people_few": "{{count}} osoby",
    "people_many": "{{count}} osób",
    "people_other": "{{count}} osoby",
    "printedOn": "Wydrukowano {{date}}",
    "page": "Strona {{number}} z {{total}}",
    "votes": "{{up}} za · {{down}} przeciw",
    "up": "{{count}} za",
    "down": "{{count}} przeciw",
    "sheetTitle": "Karta osoby",
    "scanTitle": "Kod QR do zdjęcia",
    "scanHint": "Wydrukuj go i umieść w kadrze. Zdjęcie będzie wtedy zawierać imię i nazwisko osoby, grupy, wymiary i identyfikator zasobu, więc trafi do bazy razem z jej parametrami.",
    "failed": "Nie udało się przygotować pliku PDF. Spróbuj ponownie.",
    "menu": {
      "download": "Pobierz PDF…",
      "person": "Pobierz kartę osoby",
      "actions": "Akcje dla: {{name}}",
      "button": "Pobierz PDF"
    },
    "dialog": {
      "title": "Pobierz PDF",
      "description": "Wybierz, co trafi do pliku.",
      "scope": {
        "label": "Kogo uwzględnić",
        "all": "Wszystkich z shortlisty",
        "filtered": "Według filtrów na stronie",
        "selected": "Zaznaczone osoby"
      },
      "layout": {
        "label": "Układ",
        "grid": "Siatka",
        "gridHint": "Osiem osób na stronie",
        "person": "Karty osób",
        "personHint": "Jedna osoba na stronie, z dużymi zdjęciami",
        "slate": "Plansze z kodem QR",
        "slateHint": "Duży kod QR dla każdej osoby, do umieszczenia w kadrze"
      },
      "paper": {
        "label": "Papier",
        "a4": "A4",
        "letter": "Letter"
      },
      "qr": {
        "label": "Kod QR",
        "description": "Drukuj kod każdej osoby"
      },
      "summary_one": "{{count}} osoba w pliku",
      "summary_few": "{{count}} osoby w pliku",
      "summary_many": "{{count}} osób w pliku",
      "summary_other": "{{count}} osoby w pliku",
      "loading": "Wczytywanie osób…",
      "loadFailed": "Nie udało się wczytać osób.",
      "empty": "Nikogo nie ma do wstawienia do pliku.",
      "submit": "Pobierz",
      "pictures": "Pobieranie zdjęć {{completed}} z {{total}}",
      "drawing": "Rysowanie stron…",
      "slates": {
        "label": "Plansze",
        "one": "Jedna na stronie",
        "four": "Cztery na stronie, z liniami cięcia"
      },
      "summarySlates_one": "{{count}} plansza z kodem QR w pliku",
      "summarySlates_few": "{{count}} plansze z kodem QR w pliku",
      "summarySlates_many": "{{count}} plansz z kodem QR w pliku",
      "summarySlates_other": "{{count}} planszy z kodem QR w pliku",
      "skipped_one": "{{count}} osoba nie ma wartości kodu QR i nie dostanie planszy",
      "skipped_few": "{{count}} osoby nie mają wartości kodu QR i nie dostaną planszy",
      "skipped_many": "{{count}} osób nie ma wartości kodu QR i nie dostanie planszy",
      "skipped_other": "{{count}} osoby nie mają wartości kodu QR i nie dostaną planszy",
      "noSlates": "Nikt tutaj nie ma wartości kodu QR."
    },
    "madeWith": "Przygotowano w",
    "slateCut": "Tnij wzdłuż linii przerywanych"
  }
}
